import { MatchNamesFormatterContext } from './formatters/MatchNamesFormatterContext';
import { Names, NamesFormatter } from './formatters/NamesFormatter';
import { NameStringParser } from './NameStringParser';
import {
  ANTLRErrorProps as ErrorProps,
  ANTLRExpressionsError,
  ANTLRSyntaxError,
  ErrorPrefix as ANTLRErrorPrefix,
} from './utils/Error';
import { transformToSupportedLanguage } from './utils/transformToSupportedLanguage';

// ---

export type ANTLRErrorProps = ErrorProps;
export type ANTLRNames = NonNullable<Names>;

export {
  transformToSupportedLanguage,
  ANTLRErrorPrefix,
  ANTLRExpressionsError,
  ANTLRSyntaxError,

  NameStringParser,
  MatchNamesFormatterContext,
  NamesFormatter,
};
